import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getServiceRequestHistory } from '../../../actions/service_request';
import { closeModalAction, openCustomModal } from '../../../actions/modal';
import { useEffect, useMemo } from 'react';
import moment from 'moment';
import IconToolTip from '../../../common/IconToolTip';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';
import { getChatLogs } from '../../../actions/chat';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import OverflowTip from '../../../common/OverflowTip';

const ChatLogs = ({ serviceRequest }) => {
    const dispatch = useDispatch();
    const chatLogsData = useSelector((state) => state.chat.chatLogsData);
    const isChatLogsLoading = useSelector((state) => state.loading.isChatLogsLoading);

    useEffect(() => {
        if (serviceRequest?.id && !chatLogsData[serviceRequest?.id]) {
            dispatch(getChatLogs({ id: serviceRequest?.id }));
        }
    }, [dispatch, serviceRequest?.id]);

    const logs = useMemo(() => {
        if (chatLogsData && serviceRequest?.id && chatLogsData[serviceRequest?.id]) {
            return chatLogsData[serviceRequest?.id].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
        return [];
    }, [chatLogsData, serviceRequest?.id]);

    if (isChatLogsLoading) {
        return <div className='w-full px-4'>
            <SkeltonCardTwo arr={[1, 2, 3]} height={13} />
        </div>
    }

    return (
        <div className="bg-white rounded-lg shadow-sm">
            {logs.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-8">
                    <span className="material-icons text-gray-400 text-4xl mb-2">history</span>
                    <p className="text-gray-500">No history available for this ticket</p>
                </div>
            ) : (
                <div className="relative w-full">
                    <ul className="divide-y divide-gray-100 w-full">
                        {Array.isArray(logs) && logs.map((item, index) => {

                            return (
                                <li key={item.id || index} className={`relative py-4 hover:bg-gray-50 transition-colors duration-150 ${index % 2 !== 0 ? 'bg-gray-50' : 'bg-white'}`}>
                                    <div className="flex items-start px-4 w-full">
                                        <div className="flex-1 min-w-0">
                                            <p className="text-font13 font-medium text-gray-900 truncate">
                                                {item.title}
                                            </p>
                                            <p className="text-font11 text-gray-500 mt-1 truncate max-w-[25rem]">
                                                <OverflowTip someLongText={item.content} />
                                            </p>
                                            {item.payload && item.payload.agent_name && (
                                                <p className="text-font11 text-gray-400 mt-1">
                                                    Agent: {item.payload.agent_name}
                                                </p>
                                            )}
                                        </div>
                                        <div className="flex-shrink-0 ml-2">
                                            <span className="text-sm text-gray-500">
                                                {moment(item.created_at).fromNow()}
                                            </span>
                                        </div>
                                    </div>

                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default ChatLogs;
